export const NOSIGNAL_LIST = 'NOSIGNAL_LIST';
export const NOSIGNAL_LIST_SUCCESS = 'NOSIGNAL_LIST_SUCCESS';
export const NOSIGNAL_LIST_ERROR = 'NOSIGNAL_LIST_ERROR';
export const NOSIGNAL_LIST_DETAILS = 'NOSIGNAL_LIST_DETAILS';
export const NOSIGNAL_LIST_DETAILS_ERROR = 'NOSIGNAL_LIST_DETAILS_ERROR';
export const NOSIGNAL_LIST_DETAILS_SUCCESS = 'NOSIGNAL_LIST_DETAILS_SUCCESS';

export const USERS_LIST = 'USERS_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';